import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { SxProps } from '@mui/material';

import { Logo } from './Logo';
import { LogoWrapper } from './Logo.styled';

const DEFAULT_LOGO_REDIRECT = '/' as const;

type Props = {
  disableInteraction?: boolean;
  darkMode?: boolean;
  sx?: SxProps;
};

export const LogoContainer = ({ disableInteraction, darkMode, sx }: Props) => {
  const { t } = useTranslation('common');
  return (
    <LogoWrapper
      component={disableInteraction ? 'div' : Link}
      to={disableInteraction ? undefined : DEFAULT_LOGO_REDIRECT}
      disableInteraction={disableInteraction}
      aria-label={disableInteraction ? undefined : t('a11y.home')}
      data-testid="logo-container"
      sx={sx}
    >
      <Logo variant={!darkMode ? 'dark' : 'light'} data-testid="Logo" />
    </LogoWrapper>
  );
};
